import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './components/ErrorBoundary';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={configureStore()}>
      <App />
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
